import { labelArticles, labelSelected } from "_constants";

export const FooterLeftAddCode = ({
  sourceIdsList,
}: {
  sourceIdsList: any[];
}) => {
  return (
    <>
      <div className="flex-container gap-3">
        <span className="text-footer-bold">
          {`${sourceIdsList.length} ${labelArticles}`}
        </span>
        <span>{labelSelected}</span>
      </div>
    </>
  );
};
